module.exports = __webpack_public_path__ + "media/אמבטיה.c79406c4.mp3";